// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".tag--hot[data-v-0f4b610a] {\n  background: var(--magic-alert, #ffad0d);\n}", ""]);
// Exports
module.exports = exports;
